import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useContent } from "./context/ContentContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Services from "./pages/Services";
import AgroTourism from "./pages/AgroTourism";
import Gallery from "./pages/Gallery";
import Sustainability from "./pages/Sustainability";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Enquiries from "./pages/Enquiries";
import Admin from "./pages/Admin";

const VISITOR_SEEN_KEY = "himmelstor_visitor_seen";
const VISITOR_TOTAL_KEY = "himmelstor_total_visits";
const VISITOR_UNIQUE_KEY = "himmelstor_unique_visitors";

function MainLayout() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Navbar />
      <main className="site-content flex-grow-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="products" element={<Products />} />
          <Route path="services" element={<Services />} />
          <Route path="agro-tourism" element={<AgroTourism />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="sustainability" element={<Sustainability />} />
          <Route path="blog" element={<Blog />} />
          <Route path="contact" element={<Contact />} />
          <Route path="enquiries" element={<Enquiries />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  const { isContentLoading, contentSyncWarning } = useContent();

  React.useEffect(() => {
    try {
      const total = Number(localStorage.getItem(VISITOR_TOTAL_KEY) || "0");
      localStorage.setItem(VISITOR_TOTAL_KEY, String(total + 1));

      const hasSeen = localStorage.getItem(VISITOR_SEEN_KEY) === "1";
      if (!hasSeen) {
        const unique = Number(localStorage.getItem(VISITOR_UNIQUE_KEY) || "0");
        localStorage.setItem(VISITOR_UNIQUE_KEY, String(unique + 1));
        localStorage.setItem(VISITOR_SEEN_KEY, "1");
      }
    } catch (e) {}
  }, []);

  if (isContentLoading) {
    return (
      <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center bg-light">
        <div className="spinner-border text-success" role="status" aria-label="Loading" />
        <p className="mt-3 mb-0 text-secondary">Loading Content...</p>
      </div>
    );
  }

  return (
    <>
      {contentSyncWarning && (
        <div className="alert alert-warning text-center mb-0 rounded-0 border-0 border-bottom py-2 small" role="alert">
          {contentSyncWarning}
        </div>
      )}
      <AppRoutes />
    </>
  );
}

export default App;
